import Vue from 'vue'
import request from '@/helpers/request'
import ServerValidationError from '@/helpers/ServerValidationError'
import router from '@/router'
import store from '@/store'
import snack from '@/helpers/snack'
import helper from './helper'
import axios from 'axios'

const RKO_TYPE = 0
const PKO_TYPE = 1

function checkOrdersParams(requestParams, params, unsafe = false) {
  let error = false

  if (params.includes('unit_id')) {
    if (!+requestParams.unit_id) {
      error = true
      snack.add(Vue.config.localization.ru.errorOrderUnitId)
    }
  }

  if (_.includes(params, 'items')) {
    const itemsIsEmpty = _.isEmpty(requestParams.items)
    if (itemsIsEmpty) {
      error = true
      snack.add(Vue.config.localization.ru.errorOrderHasNoItems)
    }
  }
  if (_.includes(params, 'employers')) {
    const itemsDoesNotHaveEmployer = _.some(
      requestParams.items,
      item =>
        item.item_type !== 'App\\Models\\Certificate' &&
        item.item_type !== 'App\\Models\\InstallmentPayment' &&
        item.item_type !== 'App\\Models\\Good' &&
        item.item_type !== 'App\\Models\\ClubCard' &&
        _.isEmpty(item.employer),
    )
    if (itemsDoesNotHaveEmployer) {
      error = true
      snack.add(Vue.config.localization.ru.errorOrderHasNoEmployer)
    }
  }
  if (_.includes(params, 'user')) {
    const userIsEmpty = _.isNull(requestParams.user_id)
    if (userIsEmpty) {
      error = true
      snack.add(Vue.config.localization.ru.errorOrderHasNoUser)
    }
  }
  if (_.includes(params, 'payments')) {
    const paymentsIsEmpty = _.isEmpty(requestParams.payments)
    if (paymentsIsEmpty) {
      error = true
      snack.add(Vue.config.localization.ru.errorOrderHasNoPayments)
    }
  }
  if (!unsafe && _.includes(params, 'sum')) {
    const sumServiceTotal = _.reduce(
      requestParams.items,
      (res, item) => res + parseFloat(item.price) * parseInt(item.qty),
      0,
    ).toFixed(2)
    const sumPaymentTotal = _.reduce(requestParams.payments, (res, item) => res + parseFloat(item.sum), 0).toFixed(2)
    const certPaymentsSum = _.reduce(
      requestParams.payments,
      (res, item) => (item.payment_type === Vue.config.PAYMENT_TYPES.CERT ? res + parseFloat(item.sum) : res),
      0,
    ).toFixed(2)
    const otherPaymentsSum = _.reduce(
      requestParams.payments,
      (res, item) => (item.payment_type !== Vue.config.PAYMENT_TYPES.CERT ? res + parseFloat(item.sum) : res),
      0,
    ).toFixed(2)

    const finallySum = sumPaymentTotal - otherPaymentsSum - certPaymentsSum

    if (+sumServiceTotal > +sumPaymentTotal || (+certPaymentsSum !== 0 && +finallySum !== 0)) {
      error = true
      snack.add(Vue.config.localization.ru.errorOrderSumNotMatch)
    }
  }
  return error
}

export default {
  GET_ORDERS: ({ commit, state, getters }, params) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.orders}`,
        {
          params: params,
        },
        true,
      )
        .then(response => {
          const data = response.data.data

          commit('setOrderFilters', response.data.data.filters)
          commit('setOrdersCounter', response.data.data.count)
          commit('setOrdersSummary', response.data.data.sum)

          commit('setOrders', data.items)

          resolve(data)
        })
        .catch((error, response) => {
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  GET_SELF_EMPLOYED_PAYMENT_REQUESTS: ({ commit, state }, params) => {
    return new Promise((resolve, reject) => {
      commit('setPaymentRequests', [])
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.paymentRequests.all}`,
        {
          params: params,
        },
        true,
      ).then(response => {
        const data = response.data.data
        if (params.offset === 0) {
          commit('setPaymentRequestCounter', data.count)
        }
        commit('setPaymentRequestFilters', data.filters)
        commit('updatePaymentRequests', data.items)
        resolve()
      })
    })
  },
  GET_CASH_ORDERS: ({ commit, state }, params) => {
    return new Promise((resolve, reject) => {
      commit('setCashOrders', [])
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.all}`,
        {
          params: params,
        },
        true,
      ).then(response => {
        const data = response.data.data
        commit('setCashCounter', data.count)
        commit('setCashSummary', data.sum)
        commit('setCashOrdersFilters', data.filters)
        commit('updateCashOrders', data.items)
        resolve()
      })
    })
  },
  GET_CASH_ORDER: ({ commit, state }, params) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.finances.one.replace('$order_id', params.id)}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setCashOrder', data)
      } else {
      }
    })
  },
  GET_ORDER: ({ commit, state }, params) => {
    return new Promise(resolve => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.order.replace('$order_id', params.id)}`,
        {
          params: params,
        },
        true,
      ).then(response => {
        commit('setOrder', response.data.data)

        // const translate = {
        //   total: 'Сумма',
        //   creator_id: 'Создатель (id)',
        //   company_id: 'Компания (id)',
        //   booking_id: 'Заявка (id)',
        //   user_id: 'Пользователь (id)',
        //   unit_id: 'Подразделение (id)',
        //   comment: 'Комментарий',
        //   status: 'Статус'
        // };
        //
        //
        //
        // const resultArray = [];
        // const result = response.data.data.audits.reverse();
        //
        // for (let i = 0; i < result.length; i++) {
        //   const beforeArray = [];
        //   const afterArray = [];
        //
        //   for (const key in result[i].changes) {
        //     let oldValue = result[i].changes[key][0];
        //     let newValue = result[i].changes[key][1];
        //
        //     beforeArray.push(`${translate[key] ? translate[key] : key}: <strong> ${oldValue ? oldValue : '-'}</strong>`);
        //     afterArray.push(`${translate[key] ? translate[key] : key}: <strong> ${newValue ? newValue : '-'}</strong>`);
        //   }
        //
        //   resultArray.push({
        //     date: result[i].created_at,
        //     user: result[i].user,
        //     before: beforeArray,
        //     after: afterArray
        //   })
        // }
        // commit('setOrderHistory', resultArray);
        resolve()
      })
    })
  },
  GET_ORDER_STATUSES({ commit, state }, payload) {
    return axios(`${Vue.config.server}/${Vue.config.modules.crm.api.order.status}`, { params: payload }).then(
      response => {
        store.commit('setOrderStatuses', response.data.data)
      },
    )
  },
  GET_PAYMENT_STATUSES({ commit, state }, payload) {
    return axios(`${Vue.config.server}/${Vue.config.modules.crm.api.payment.status}`, { params: payload }).then(
      response => {
        store.commit('setPaymentStatuses', response.data.data)
      },
    )
  },
  GET_PAYMENT_TYPES({ commit, state }, payload) {
    return axios(`${Vue.config.server}/${Vue.config.modules.crm.api.payment.type}`, { params: payload }).then(
      response => {
        store.commit('setPaymentTypes', response.data.data)
      },
    )
  },
  REFRESH_ONLINE_PAYMENTS(context, orderId) {
    return axios(`${Vue.config.server}/${Vue.config.modules.crm.api.payment.refresh}`, {
      params: { order_id: orderId },
    })
  },
  GET_CASH_ORDER_OPERATIONS: ({ commit, state }, params) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.operation}`,
        {
          params: params,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setCashOrdersOperations', data.items)

          resolve()
        })
        .catch(err => {
          reject()
        })
    })
  },
  GET_CASH_ORDER_BASIS: ({ commit, state }, params) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.finances.basis}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setCashOrdersBasis', data.items)
      } else {
      }
    })
  },
  DISCOUNT_ORDER: ({ commit, state }, params) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.finances.discount.replace('$order_id', params.id)}`,
      {},
      true,
    ).then(response => {
      store.dispatch('GET_ORDER', {
        id: params.id,
        with: 'items;items.item;items.employer;user;payments;unit;booking;booking.servicesWithWindow;creator;images',
      })
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    })
  },
  UPDATE_ORDER: ({ commit, state }, params) => {
    let requestParams = _.cloneDeep(params)
    const id = params.id

    requestParams.promotion_ids = requestParams.promotions.map(promotion => promotion.id)
    requestParams.promotions = requestParams.promotions.map(promotion => promotion.id)

    requestParams = _.omit(requestParams, ['id', 'user', 'unit', 'booking', 'creator'])
    if (_.isNull(requestParams.booking_id)) {
      requestParams = _.omit(requestParams, ['booking_id'])
    }
    if (_.isNull(requestParams.check_printed_at)) {
      requestParams = _.omit(requestParams, ['check_printed_at'])
    }

    if (requestParams.hasOwnProperty('image') && _.isArray(requestParams.image) && requestParams.image.length === 0) {
      delete requestParams.image
    }

    requestParams._method = 'PUT'

    let round = !requestParams.items.find(item => item.notRound)

    if (params.company_id === 1 && !requestParams.checkRefaund && round) {
      for (let i = 0; i < requestParams.payments.length; i++) {
        requestParams.payments[i].amount = +requestParams.payments[i].amount * 100
        // requestParams.payments[i].payment_type = requestParams.payments[i].provider
      }

      for (let i = 0; i < requestParams.items.length; i++) {
        requestParams.items[i].price = +requestParams.items[i].price * 100
      }

      const totalPayments = requestParams.payments.reduce(
        (accumulator, currentValue) => accumulator + +currentValue.amount,
        0,
      )
      const totalSum = requestParams.items.reduce(
        (accumulator, currentValue) => accumulator + +currentValue.price * currentValue.qty,
        0,
      )
      const conf = totalSum / totalPayments

      for (let i = 0; i < requestParams.items.length; i++) {
        requestParams.items[i].price = Math.trunc(requestParams.items[i].price / conf)
      }

      const newTotalPayments = requestParams.payments.reduce(
        (accumulator, currentValue) => accumulator + +currentValue.amount,
        0,
      )
      const newTotalSum = requestParams.items.reduce(
        (accumulator, currentValue) => accumulator + +currentValue.price * +currentValue.qty,
        0,
      )

      if (newTotalPayments > newTotalSum) {
        let index = requestParams.items.findIndex(x => +x.qty === 1)
        index = index === -1 ? 0 : index
        requestParams.items[index].price += newTotalPayments - newTotalSum
      } else if (newTotalPayments < newTotalSum) {
        const newItem = JSON.parse(JSON.stringify(requestParams.items[requestParams.items.length - 1]))
        requestParams.items[requestParams.items.length - 1].qty -= 1
        newItem.price = newItem.price - (newTotalSum - newTotalPayments)
        newItem.qty = 1
        requestParams.items.push(newItem)
      }

      for (let i = 0; i < requestParams.payments.length; i++) {
        requestParams.payments[i].amount = +requestParams.payments[i].amount / 100
      }

      for (let i = 0; i < requestParams.items.length; i++) {
        requestParams.items[i].price = +requestParams.items[i].price / 100
      }

      const hasErrors = checkOrdersParams(
        requestParams,
        ['items', 'user', 'employers', 'payments', 'unit_id'],
        params.unsafe,
      )
      if (hasErrors) return false
    } else {
      const hasErrors = checkOrdersParams(
        requestParams,
        ['items', 'sum', 'user', 'employers', 'payments', 'unit_id'],
        params.unsafe,
      )
      if (hasErrors) return false
    }

    requestParams.items = _.map(requestParams.items, item => {
      return _.omit(item, ['employer', 'item'])
    })

    delete requestParams.audits
    if (requestParams.checkRefaund) delete requestParams.checkRefaund

    const formData = helper(requestParams, { indices: true })
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.finances.order.replace('$order_id', id)}`,
      {
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Locale': navigator.language.substr(0, 2),
        },
      },
      true,
    )
      .then(() => {
        // TODO в ответ на сохранение приходит не полный объект и все рушится нахер. приходится перезапрашивать
        return request(
          'GET',
          `${Vue.config.server}/${Vue.config.modules.crm.api.finances.order.replace('$order_id', id)}`,
          {
            params: {
              with:
                'items;items.item;items.employer;user.wallet;payments;unit;booking;booking.servicesWithWindow;creator;images;promotions;booking.user;booking.user.clubCard;booking.clubCards',
            },
          },
          true,
        ).then(response => {
          const data = response.data.data
          commit('setOrder', data)
          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
          return data
        })
      })
      .catch(e => {
        if (e.response.data.code === 1720) {
          snack.add('Выберите пилочки')
        } else if (e.response.data.code === 1011) {
          snack.add(Vue.config.localization.ru.forbiddenExceptionOrders)
        } else {
          snack.add(Vue.config.localization.ru.errorSavingMessage)
        }
        throw e
      })
  },
  CREATE_ORDER: ({ commit, state }, params) => {
    let requestParams = _.cloneDeep(params)

    requestParams = _.omit(requestParams, ['id', 'user', 'unit', 'booking', 'creator'])
    if (_.isNull(requestParams.booking_id)) {
      requestParams = _.omit(requestParams, ['booking_id'])
    }
    if (_.isNull(requestParams.check_printed_at)) {
      requestParams = _.omit(requestParams, ['check_printed_at'])
    }

    if (requestParams.hasOwnProperty('image') && _.isArray(requestParams.image) && requestParams.image.length === 0) {
      delete requestParams.image
    }

    let round = !requestParams.items.find(item => item.notRound)

    if (params.company_id === 1 && round) {
      for (let i = 0; i < requestParams.payments.length; i++) {
        requestParams.payments[i].sum = +requestParams.payments[i].sum * 100
      }

      for (let i = 0; i < requestParams.items.length; i++) {
        requestParams.items[i].price = +requestParams.items[i].price * 100
      }

      const totalPayments = requestParams.payments.reduce(
        (accumulator, currentValue) => accumulator + +currentValue.sum,
        0,
      )
      const totalSum = requestParams.items.reduce(
        (accumulator, currentValue) => accumulator + +currentValue.price * currentValue.qty,
        0,
      )
      const conf = totalSum / totalPayments

      for (let i = 0; i < requestParams.items.length; i++) {
        requestParams.items[i].price = Math.trunc(requestParams.items[i].price / conf)
      }

      const newTotalPayments = requestParams.payments.reduce(
        (accumulator, currentValue) => accumulator + +currentValue.sum,
        0,
      )
      const newTotalSum = requestParams.items.reduce(
        (accumulator, currentValue) => accumulator + +currentValue.price * +currentValue.qty,
        0,
      )

      if (newTotalPayments > newTotalSum) {
        let index = requestParams.items.findIndex(x => +x.qty === 1)
        index = index === -1 ? 0 : index
        requestParams.items[index].price += newTotalPayments - newTotalSum
      } else if (newTotalPayments < newTotalSum) {
        const newItem = JSON.parse(JSON.stringify(requestParams.items[requestParams.items.length - 1]))
        requestParams.items[requestParams.items.length - 1].qty -= 1
        newItem.price = newItem.price - (newTotalSum - newTotalPayments)
        newItem.qty = 1
        requestParams.items.push(newItem)
      }

      for (let i = 0; i < requestParams.payments.length; i++) {
        requestParams.payments[i].sum = +requestParams.payments[i].sum / 100
      }

      for (let i = 0; i < requestParams.items.length; i++) {
        requestParams.items[i].price = +requestParams.items[i].price / 100
      }

      const hasErrors = checkOrdersParams(requestParams, ['items', 'user', 'employers', 'payments', 'unit_id'])
      if (hasErrors) return false
    } else {
      const hasErrors = checkOrdersParams(requestParams, ['items', 'sum', 'user', 'employers', 'payments', 'unit_id'])
      if (hasErrors) return false
    }

    requestParams.items = _.map(requestParams.items, item => {
      return _.omit(item, ['employer', 'item'])
    })

    const data = helper(requestParams, { indices: true })

    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.finances.orders}`,
      {
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Locale': navigator.language.substr(0, 2),
        },
      },
      true,
    )
      .then(response => {
        router.push({ name: 'finance-order-view', params: { orderId: response.data.data.id } })
        snack.add(Vue.config.localization.ru.savedMessage, 'primary')
      })
      .catch(error => {
        if (error.response.data.code === 1720) {
          snack.add('Выберите пилочки')
        } else if (error.response.data.code === 2100) {
          snack.add('Примите обязательные материалы')
        } else {
          snack.add(Vue.config.localization.ru.errorSavingMessage)
        }
        throw error
      })
  },
  UPDATE_CASH_ORDER: ({ commit, state }, params) => {
    let requestParams = _.cloneDeep(params)
    const id = params.id

    requestParams = _.omit(requestParams, ['id', 'employer', 'recipient', 'sender', 'operation'])

    return new Promise((resolve, reject) => {
      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.one.replace('$order_id', id)}`,
        requestParams,
        true,
      ).then(response => {
        resolve()
      })
    })
  },
  CREATE_CASH_ORDER({ commit, state }, params) {
    let requestParams = _.cloneDeep(params)
    requestParams = _.omit(requestParams, ['id', 'employer', 'recipient', 'sender', 'operation'])

    return new Promise((resolve, reject) => {
      request(
        'POST',
        // TODO Сделать запрос для создания и урлу сюда вписать правильную
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.all}`,
        requestParams,
        true,
      )
        .then(response => {
          if (response.data.result === 'success') {
            if (params.type === RKO_TYPE) {
              router.push({ name: 'finance-rko-view', params: { orderId: response.data.data.id } })
            }
            if (params.type === PKO_TYPE) {
              router.push({ name: 'finance-pko-view', params: { orderId: response.data.data.id } })
            }
          }
          resolve()
        })
        .catch(e => {
          ServerValidationError.notify(e, 'createCashOrderValidation')
          reject()
        })
    })
  },

  async GET_SALARY({ commit, state }, id) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.salary.replace('$1', id)}`,
        {
          params: {
            with: 'items;items.employer',
          },
        },
        true,
      )
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setSalary', data)
      } else {
        throw response
      }
    } catch (error) {
      console.info(error)
      snack.add(Vue.config.localization.ru.errors.salaryError)
    }
  },

  async REMOVE_SALARY({ commit, state }, id) {
    try {
      const response = await request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.salary.replace('$1', id)}`,
        {},
        true,
      )
      if (response.data.result === 'success') {
        // const data = response.data.data;
        // commit('setSalary', data);
      } else {
        throw response
      }
    } catch (error) {
      console.info(error)
      snack.add(Vue.config.localization.ru.errors.salaryError)
    }
  },

  async GET_SALARIES({ commit, state }, params) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.salaries}`,
        {
          params: params,
        },
        true,
      )
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('updateSalaries', data.items)
      } else {
        throw response
      }
    } catch (error) {
      console.info(error)
      snack.add(Vue.config.localization.ru.errors.salaryGenerationError)
    }
  },

  async FETCH_SALARIES({ commit, state }, params) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.salaries}`,
        {
          params: params,
        },
        true,
      )
      return { items: response.data.data.items, count: response.data.data.count }
    } catch (error) {
      console.info(error)
      snack.add(Vue.config.localization.ru.errors.salaryGenerationError)
      return []
    }
  },

  async CREATE_SALARY({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.finances.salaryCalculate}`,
        {
          params: params,
        },
        true,
      )
        .then(() => {
          return resolve()
        })
        .catch(err => {
          return reject(err)
        })
    })
  },

  async INITIALIZE_PKO_VIEW_NEW({ commit, dispatch }) {
    commit('setLoad', true)
    commit('setTitle', 'НОВЫЙ ПКО')
    commit('clearCashOrder')
    await Promise.all([dispatch('GET_CASH_ORDER_OPERATIONS'), dispatch('GET_CASH_ORDER_BASIS')])
    commit('setLoad', false)
  },

  async INITIALIZE_RKO_VIEW_NEW({ commit, dispatch }) {
    commit('setLoad', true)
    commit('setTitle', 'НОВЫЙ РКО')
    commit('clearCashOrder')
    await Promise.all([dispatch('GET_CASH_ORDER_OPERATIONS'), dispatch('GET_CASH_ORDER_BASIS')])
    commit('setLoad', false)
  },
  GET_CERTIFICATE_BY_NUMBER({ commit, state }, certificateNumber) {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.finances.certificateOne}`, {
      params: {
        certificate_number: certificateNumber,
      },
    })
      .then(response => {
        if (response.data.result === 'success' && !_.isEmpty(response.data.data)) {
          return response.data.data
        } else {
          const message = response?.data?.exception.includes('CertificateIsTooYoungException')
            ? Vue.config.localization.ru.certificateIsTooYoung
            : Vue.config.localization.ru.certificateNotFound

          snack.add(message)
        }
      })
      .catch(error => {
        if (error?.response?.data.code === 1760) {
          snack.add(Vue.config.localization.ru.saleIsTooOld)

          return
        }

        if (error?.response?.data?.exception?.includes('CertificateIsTooYoungException')) {
          snack.add(Vue.config.localization.ru.certificateIsTooYoung)
        } else {
          if (error?.response?.data?.message !== '') {
            snack.add(error?.response?.data?.message)
          }
        }
      })
  },
}
